import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
const firebaseConfig = {
    apiKey: "AIzaSyDr2fDebsG8O8B7Eqeovnb4vbPo6rRWgKk",
    authDomain: "mohandes-1eeb5.firebaseapp.com",
    projectId: "mohandes-1eeb5",
    storageBucket: "mohandes-1eeb5.firebasestorage.app",
    messagingSenderId: "661234446795",
    appId: "1:661234446795:web:8d2b10c3b53ccc3c38464e",
    measurementId: "G-X386BG3E30"
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export { messaging };
